import useSWR from "swr";
import useWebInstance from "grandus-lib/hooks/useWebInstance";

import { Card } from "antd";
import { isEmpty, get, toNumber, find } from "lodash";
import IsicForm from "components/forms/Isic";

const Isic = () => {
  const { settings } = useWebInstance();
  const { data: staticBlocks, isValidating } = useSWR(
    `/api/lib/v1/blocks`,
    (url) => fetch(url).then((r) => r.json()),
    {
      revalidateOnReconnect: false,
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  if (!toNumber(settings?.isic_active)) {
    return null;
  }

  const cartIsicDescription = get(
    find(staticBlocks, ["hash", "cart_isic_description"]),
    "content",
    ""
  );
  return (
    <Card title={"ISIC"}>
      {!isEmpty(cartIsicDescription) ? (
        <div dangerouslySetInnerHTML={{ __html: cartIsicDescription }} />
      ) : (
        <div>
          Tu môžete uplatniť svjoju ISIC zľavu. Stačí zadať meno a číslo
          preukazu.
        </div>
      )}

      <div style={{ marginTop: "15px" }}>
        <IsicForm />
      </div>
    </Card>
  );
};

export default Isic;
